// Original code taken from:

/* Detect-zoom
* -----------
* Cross Browser Zoom and Pixel Ratio Detector
* Version 1.0.4 | Apr 1 2013
* dual-licensed under the WTFPL and MIT license
* Maintained by https://github/tombigel
* Original developer https://github.com/yonran
*/

// converted to typescript and simplified / cut down (mostly removed unsupported browsers)

//import * as $ from 'jquery';

export function detectZoom() {
    if (!isNaN((<any>screen).logicalXDPI) && !isNaN((<any>screen).systemXDPI)) {
        return ie();
    }
    else if ((<any>window).opera || navigator.userAgent.indexOf('OPR/') >= 0) {
        return notAvailable();
    }
    else if (!!(<any>window).chrome) {
        return chrome();
    }
    else if (Object.prototype.toString.call((<any>window).HTMLElement).indexOf('Constructor') > 0) {
        // untested
        return safari();
    }
    else if ('orientation' in window && 'webkitRequestAnimationFrame' in window) {
        // untested
        return webkitMobile();
    }
    else if ('webkitRequestAnimationFrame' in window) {
        // untested
        return webkit();
    }
    else if ((<any>window).devicePixelRatio) {
        return firefox();
    }

    return notAvailable();
}

function devicePixelRatio() {
    return window.devicePixelRatio || 1;
};

function notAvailable() {
    return {
        zoom: 1,
        devicePxPerCssPx: 1
    };
};

function ie() {
    const zoom = Math.round(((<any>screen).deviceXDPI / (<any>screen).logicalXDPI) * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * devicePixelRatio()
    };
};

function chrome() {
    var zoom = Math.round(((window.outerWidth) / window.innerWidth) * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * devicePixelRatio()
    };
}

function safari() {
    var zoom = Math.round(((document.documentElement.clientWidth) / window.innerWidth) * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * devicePixelRatio()
    };
}

function webkitMobile() {
    var deviceWidth = (Math.abs((<any>window).orientation) == 90) ? screen.height : screen.width;
    var zoom = deviceWidth / window.innerWidth;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * devicePixelRatio()
    };
};

function webkit() {
    var important = function (str) {
        return str.replace(/;/g, " !important;");
    };

    var div = document.createElement('div');
    div.innerHTML = "1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0";
    div.setAttribute('style', important('font: 100px/1em sans-serif; -webkit-text-size-adjust: none; text-size-adjust: none; height: auto; width: 1em; padding: 0; overflow: visible;'));

    // The container exists so that the div will be laid out in its own flow
    // while not impacting the layout, viewport size, or display of the
    // webpage as a whole.
    // Add !important and relevant CSS rule resets
    // so that other rules cannot affect the results.
    var container = document.createElement('div');
    container.setAttribute('style', important('width:0; height:0; overflow:hidden; visibility:hidden; position: absolute;'));
    container.appendChild(div);

    document.body.appendChild(container);
    var zoom = 1000 / div.clientHeight;
    zoom = Math.round(zoom * 100) / 100;
    document.body.removeChild(container);

    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * devicePixelRatio()
    };
};

function firefox() {
    return {
        zoom: mediaQueryBinarySearch('min--moz-device-pixel-ratio', '', 0, 10, 20, 0.0001),
        devicePxPerCssPx: devicePixelRatio()
    };
};

function mediaQueryBinarySearch(property, unit, a, b, maxIter, epsilon) {
    var matchMedia;
    var head, style, div;
    if (window.matchMedia) {
        matchMedia = window.matchMedia;
    } else {
        head = document.getElementsByTagName('head')[0];
        style = document.createElement('style');
        head.appendChild(style);

        div = document.createElement('div');
        div.className = 'mediaQueryBinarySearch';
        div.style.display = 'none';
        document.body.appendChild(div);

        matchMedia = function (query) {
            style.sheet.insertRule('@media ' + query + '{.mediaQueryBinarySearch ' + '{text-decoration: underline} }', 0);
            var matched = getComputedStyle(div, null).textDecoration == 'underline';
            style.sheet.deleteRule(0);
            return { matches: matched };
        };
    }
    var ratio = binarySearch(a, b, maxIter);
    if (div) {
        head.removeChild(style);
        document.body.removeChild(div);
    }
    return ratio;

    function binarySearch(a, b, maxIter) {
        var mid = (a + b) / 2;
        if (maxIter <= 0 || b - a < epsilon) {
            return mid;
        }
        var query = "(" + property + ":" + mid + unit + ")";
        if (matchMedia(query).matches) {
            return binarySearch(mid, b, maxIter - 1);
        } else {
            return binarySearch(a, mid, maxIter - 1);
        }
    }
};
